import api from './axios';

// 비밀번호 확인
export const passwordCheck = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyPasswordCheck',{params: params});
  return response.data;
};

// 내정보 상세조회
export const memberDetail = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyInfoDetail',{params: params});
  return response.data;
};

// 내정보 수정
export const updateMember = async (params) => {
  const response = await api.post('/knouUser/mypage/updateMyInfo', params);
  return response.data;
};

// 수강진행상태 조회
export const getMyCourseCnt = async (params) => {
  const response = await api.get('/knouUser/mypage/getMyCourseCnt', {params: params});
  return response.data;
};

// 내정보 삭제
export const deleteMember = async (params) => {
  const response = await api.post('/knouUser/mypage/deleteMyInfo', params);
  return response.data;
};

// 비밀번호재설정
export const myUpdatePassword = async (reqData) => {
  const response = await api.post('/knouUser/mypage/myUpdatePassword', reqData);
  return response.data;
};

// 비밀번호 한달후변경
export const updateMonthChangePassword = async (reqData) => {
  const response = await api.post('/knouUser/mypage/updateMonthChangePassword', reqData);
  return response.data;
};
